// extracted by mini-css-extract-plugin
export default {"menu":"SortByButton_menu__QIOmQ","box":"SortByButton_box__dwgzw"};